import { actionTypes } from "../actions/default.action"

const initialState = {
  modules: {
    data: [],
  },
  module: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        modules: {
          ...state.modules,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        modules: {
          ...state.modules,
          data: state.modules.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        module: {
          ...state.module,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
